import { Box, makeStyles, Theme, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import { FC, memo } from "react";

import { WeekDay } from "../../../types/generic.types";
import { ISlot } from "../../../types/resource.types";
import { areEqual } from "../../../utils/generic";

const days: ISlot[] = [
  { id: WeekDay.saturday, name: "Saturday" },
  { id: WeekDay.sunday, name: "Sunday" },
  { id: WeekDay.monday, name: "Monday" },
  { id: WeekDay.tuesday, name: "Tuesday" },
  { id: WeekDay.wednesday, name: "Wednesday" },
  { id: WeekDay.thursday, name: "Thursday" },
  { id: WeekDay.friday, name: "Friday" },
];

const daysResponsive: ISlot[] = [
  { id: WeekDay.saturday, name: "Sat" },
  { id: WeekDay.sunday, name: "Sun" },
  { id: WeekDay.monday, name: "Mon" },
  { id: WeekDay.tuesday, name: "Tue" },
  { id: WeekDay.wednesday, name: "Wed" },
  { id: WeekDay.thursday, name: "Thur" },
  { id: WeekDay.friday, name: "Fri" },
];

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    background: theme.palette.primary.main,
    borderRadius: 5,
    overflow: "hidden",
  },
  day: {
    flex: 1,
    textAlign: "center",
    borderBottom: "5px solid transparent",
    cursor: "pointer",
    color: theme.palette.grey[100],

    "&:hover": {
      background: theme.palette.primary.dark,
    },
  },
  selected: {
    borderBottom: `5px solid ${theme.palette.primary.dark}`,
  },
}));

const AvailabilityTab: FC<AvailabilityTabProps> = ({ selectedDay, setSelectedId, hasSlots }) => {
  const classes = useStyles({});
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Box className={classes.container} flexWrap={isSm ? "" : "nowrap"}>
      {isSm
        ? daysResponsive.map((day) => (
            <Box
              key={day.id}
              className={clsx([classes.day, { [classes.selected]: selectedDay === day.id }])}
              onClick={() => setSelectedId(day.id)}
              padding="10px 6px"
            >
              {day.name}
              {hasSlots(day.id) && "*"}
            </Box>
          ))
        : days.map((day) => (
            <Box
              key={day.id}
              className={clsx([classes.day, { [classes.selected]: selectedDay === day.id }])}
              onClick={() => setSelectedId(day.id)}
              padding={2}
            >
              {day.name}
              {hasSlots(day.id) && "*"}
            </Box>
          ))}
    </Box>
  );
};

interface AvailabilityTabProps {
  selectedDay: WeekDay;
  setSelectedId: (day: WeekDay) => void;
  hasSlots: (day: WeekDay) => boolean;
}

export default memo(AvailabilityTab, areEqual);
